const initState={
    rating:{}
}

const ratingReducer = (state=initState,action) => {
 switch(action.type){
    case "GET_RATING":
        return{
            ...state,
            rating:action.payload
        }
        default:
            return{...state}
 }
}

export default ratingReducer
